import { useEffect } from "react";

import { OrderFields } from "../../constants";
import getIsDeliveryIntraEurope from "../../utils/getIsDeliveryIntraEurope";
import useOrderFormik from "../useOrderFormik";

const useUpdateIsIntraEurope = (): void => {
  const {
    values: { [OrderFields.STARTING_COUNTRY]: countryFrom, [OrderFields.DESTINATION_COUNTRY]: countryTo },
    setFieldValue,
  } = useOrderFormik();

  useEffect(() => {
    const isIntraEurope = getIsDeliveryIntraEurope(countryFrom!, countryTo!);
    setFieldValue(OrderFields.IS_INTRA_EUROPE, isIntraEurope);
  }, [countryFrom, countryTo, setFieldValue]);
};
export default useUpdateIsIntraEurope;
